import React from 'react';
import './Spinner.css';

function Spinner() {
  return (
    <div className="spinner">
      <div className="spinner-inner"></div>
    </div>
  );
}

export default Spinner; 